import { useId } from 'react';
import type { BuildTuple } from '@/types/build-tuple';

export const useIds = <N extends number>(length: N): BuildTuple<N, string> => {
  const baseId = useId();

  return Array.from({ length }, (_, idx) => `${baseId}-${idx}`) as BuildTuple<
    N,
    string
  >;
};
